import styledComponents, { useTheme, withTheme } from 'styled-components';
import { ThemePaletteType } from './typings';
import paletteLight from './paletteLight';
import paletteDark from './paletteDark';
import defaultZIndex from './zIndex';
export var styled = styledComponents;
export { useTheme, withTheme };
export var createTheme = function createTheme( // eslint-disable-next-line @typescript-eslint/default-param-last
type, colors, zIndex) {
  if (type === void 0) {
    type = ThemePaletteType.Light;
  }

  if (zIndex === void 0) {
    zIndex = defaultZIndex;
  }

  var theme = {
    type: type,
    zIndex: zIndex,
    fontFamilyLegacy: 'Roboto, sans-serif',
    fontFamily: 'Inter var, system-ui',
    palette: type === ThemePaletteType.Dark ? paletteDark : paletteLight,
    colors: colors
  };
  return theme;
};